module.exports = __webpack_public_path__ + "static/media/ic_list.fab7d6a8.svg";